import { 
    ADD_FETCHING_MEDIA,
    INIT_FETCHING_MEDIA,
} from 'redux/fetchingMedia/actions'
import { range } from 'lodash'

const initialState = []

export const fetchingMedia = (state = initialState, {type, start,end}) => {
    switch (type)
    {
        case ADD_FETCHING_MEDIA:
            const fetchingIndexes = range(start, (end + 1))
            
            return state.concat(fetchingIndexes)

        case INIT_FETCHING_MEDIA:
            return initialState
        
        default:
            return state
    }
}
